import {generatePseudo} from "@/utils/pseudoGenerator.js";
import {generateHolyPseudo} from "@/utils/holyPseudoGenerator.js";

// --- MOCK COTES ---
export const MOCK_ODDS_LIST = [
    // --- VAINQUEUR (Live 81' : Argentine mène 1-2) ---
    // France gagne (Doit mettre 2 buts en 10min) -> Miracle
    {marketType: 'HOME_WINNER', value: 25.00, label: '1'},
    // Match nul (France égalise 2-2) -> Possible mais dur
    {marketType: 'DRAW', value: 6.50, label: 'N'},
    // Argentine gagne (Score actuel ou plus) -> Très probable
    {marketType: 'AWAY_WINNER', value: 1.15, label: '2'},

    // --- SCORES EXACTS ---

    // Le plus probable : Le score ne bouge plus
    {marketType: 'EXACT_SCORE', value: 1.55, label: '1:2'},

    // Les scénarios "Crédibles" de fin de match
    {marketType: 'EXACT_SCORE', value: 8.00, label: '2:2'},
    {marketType: 'EXACT_SCORE', value: 7.50, label: '1:3'},

    // Les scénarios "Fous"
    {marketType: 'EXACT_SCORE', value: 15.00, label: '2:3'},
    {marketType: 'EXACT_SCORE', value: 60.00, label: '3:2'},

    // Les scores impossibles (Déjà passés), on met 100 ou on laisse pour l'UI
    {marketType: 'EXACT_SCORE', value: 100.00, label: '1:0'},
    {marketType: 'EXACT_SCORE', value: 100.00, label: '2:0'},
    {marketType: 'EXACT_SCORE', value: 100.00, label: '2:1'}, // C'était possible avant, plus maintenant
    {marketType: 'EXACT_SCORE', value: 100.00, label: '3:0'},
    {marketType: 'EXACT_SCORE', value: 100.00, label: '3:1'},
    {marketType: 'EXACT_SCORE', value: 100.00, label: '0:0'},
    {marketType: 'EXACT_SCORE', value: 100.00, label: '1:1'},
    {marketType: 'EXACT_SCORE', value: 100.00, label: '0:1'},
    {marketType: 'EXACT_SCORE', value: 100.00, label: '0:2'},
];

const randInt = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;
const randFloat = (min, max, decimals = 2) => {
    const v = Math.random() * (max - min) + min;
    const p = Math.pow(10, decimals);
    return Math.round(v * p) / p;
};

// Génère un pari cohérent basé sur la "qualité" requise
const generateSmartPrediction = (targetHome, targetAway, quality) => {
    if (quality === 'EXACT') {
        return {home: targetHome, away: targetAway};
    }

    const targetDiff = targetHome - targetAway;

    if (quality === 'WINNER') {
        let h, a;
        do {
            h = randInt(0, 3);
            a = randInt(0, 3);
        } while (
            (h === targetHome && a === targetAway) ||
            Math.sign(h - a) !== Math.sign(targetDiff)
            );
        return {home: h, away: a};
    }

    // LOOSER
    let h, a;
    do {
        h = randInt(0, 3);
        a = randInt(0, 3);
    } while (Math.sign(h - a) === Math.sign(targetDiff));
    return {home: h, away: a};
};

export const makeMockFootballLeaderboardBackend = (
    count = 30,
    {
        meIndex = count - 1,
        startId = 100,
        targetScore = {home: 1, away: 2}
    } = {}
) => {
    const seen = new Set();
    const uniquePseudo = () => {
        let p = generateHolyPseudo();
        while (seen.has(p)) p = generateHolyPseudo();
        seen.add(p);
        return p;
    };

    const STAKE = 100; // La mise de départ

    let list = Array.from({length: count}, (_, i) => {
        const isMe = i === meIndex;
        let quality;
        let calculatedPoints;

        // On définit des cotes réalistes pour chaque joueur
        // (Pour l'affichage, même si on ne les utilise pas toutes pour le calcul)
        let oddsExact = randFloat(5.0, 12.0, 1); // Cote Score Exact (ex: 7.5)
        let oddsWin = randFloat(1.4, 2.8, 2);    // Cote Vainqueur (ex: 1.80)

        // --- 1. LES GÉNIES (Top 15%) ---
        // Ils ont le score exact. Ils raflent la mise x la grosse cote.
        if (i < count * 0.15) {
            quality = 'EXACT';
            // Points = Mise * Cote Exacte (ex: 100 * 7.5 = 750 pts)
            calculatedPoints = Math.floor(STAKE * oddsExact);
        }

            // --- 2. LES SUIVEURS (40% suivants) ---
        // Ils ont le bon vainqueur. Ils gagnent Mise x Petite cote.
        else if (i < count * 0.55) {
            quality = 'WINNER';
            // Points = Mise * Cote Vainqueur (ex: 100 * 1.8 = 180 pts)
            calculatedPoints = Math.floor(STAKE * oddsWin);
        }

            // --- 3. LES TOURISTES (Le reste) ---
        // Ils ont perdu.
        else {
            quality = 'LOOSER';
            calculatedPoints = 0; // Ils ont perdu leur mise
        }

        const prediction = generateSmartPrediction(targetScore.home, targetScore.away, quality);

        return {
            participantId: startId + i,
            pseudo: uniquePseudo(),
            isMe: isMe,
            predictionHome: prediction.home,
            predictionAway: prediction.away,
            betAt: new Date().toISOString(),
            oddsExactScore: oddsExact,
            oddsWinner: oddsWin,
            totalPoints: calculatedPoints,
            rank: null,
        };
    });

    // TRI PAR POINTS DÉCROISSANTS
    list.sort((a, b) => b.totalPoints - a.totalPoints);

    // GESTION DU "MOI" APRÈS LE TRI
    // On veut que "Moi" soit à la position demandée (meIndex)
    // Et on doit adapter mes points pour que ce soit cohérent avec mes voisins
    if (meIndex >= 0 && meIndex < list.length) {
        // Reset des flags
        list.forEach(p => p.isMe = false);

        // On prend l'objet à la position voulue
        const myUser = list[meIndex];
        myUser.isMe = true;
        myUser.pseudo = "Moi (Demo)"; // Pour bien te repérer

        // Si tu es mal classé (ex: 12ème sur 30), tu es probablement un 'WINNER' ou 'LOOSER'
        // Le code a déjà généré des points cohérents pour cette position via le tri.
        // Mais pour la démo, si tu veux simuler le passage de 0 à 1er,
        // assure-toi que ton état initial (avant le but) est bas.
    }

    // Attribution finale des Rangs
    list.forEach((p, idx) => {
        p.rank = idx + 1;
    });

    return list;
};